import axios from "axios";

const api = axios.create({
  baseURL: "https://prime-precision-backend-server-il2j.onrender.com/api",
});
export default api;
